{
  "iframeWaitingMessage": "Merci pour votre patience. Encore quelques instants...",
  "solutionIframe": "Contenu principal",
  "unloadPromptMessage": "Confirmez-vous votre choix ?"
}
